(() => {
  const WIDGET_SELECTOR = '.jdgm-review-widget';
  const CARD_SELECTOR = '.jm-review-item[review-uuid]';
  let scheduled = false;

  const COPY_FIXES = new Map([
    ['2-Year Trade-In', '2-Year Limited Warranty'],
    ['Two years trade in', '2-Year Limited Warranty'],
    ['Two-year trade-in support for eligible products; terms and exclusions apply.', 'Coverage terms and exclusions apply.'],
    ['Eligible Returns', 'Clear Return Policy'],
    ['Unused, uncut and uninstalled items may be returned under our refund policy.', 'Non-quality returns, exchanges or refunds are not accepted after shipment. See our refund policy for details.'],
    ['14-day returns for eligible unused items · 2-year limited warranty (terms apply)', 'Non-quality returns are not accepted after shipment · 2-Year Limited Warranty (terms apply)'],
    ["94.5'' x 47.2'' (2400mm x 1200mm)", "94.5'' x 46.2''"],
    ['The foam imitation teak boat deck hardware mat can be easily cleaned with broom or vacuum cleaner, or be pressure washed.', 'For normal care, rinse with fresh water. Use mild soap or detergent with a soft brush or sponge when needed. Avoid harsh chemicals and high-pressure washing, especially around edges and seams.'],
    ['It is not easy to become hot in the sunlight, and it will not burn your feet when you stand on it with bare feet.', 'EVA foam provides cushioning underfoot. Surface temperature varies with color, sunlight, airflow, and exposure.'],
    ['The non-slip surface gives you a good grip on the boat. No need to worry about wet feet making you fall.', 'The textured surface is designed to improve underfoot traction. Grip varies with water, contaminants, wear, and footwear.'],
    ['UV-protected surface stays cooler under the sun', 'Textured EVA surface provides cushioning; surface temperature varies with sun exposure'],
    ['includes anti-UV additives to prevent fading and heat absorption.', 'uses UV-resistant materials; appearance and surface temperature vary with sun exposure, color, use, and care.'],
    ["Designed for harsh marine environments, it's resistant to saltwater, UV rays, and everyday wear. Perfect for long-lasting, comfortable boat decking.", 'Designed for marine use with closed-cell EVA foam. Service life varies with exposure, installation, use, and care.'],
    ['Ships within 1-2 business days.', 'Dispatches in 1–3 business days.'],
    ['🔥Up to 10% off', '🔥 2\u00A0SHEETS 5% OFF · 3+\u00A0SHEETS 10% OFF'],
    ['2 SHEETS 5% OFF · 3+ SHEETS 10% OFF', '🔥 2\u00A0SHEETS 5% OFF · 3+\u00A0SHEETS 10% OFF']
  ]);

  const normalizeStorefrontCopy = () => {
    const root = document.getElementById('MainContent') || document.body;
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const raw = node.nodeValue;
      if (!raw || !raw.trim()) return;
      let next = raw;
      COPY_FIXES.forEach((replacement, source) => {
        if (next.includes(source)) next = next.split(source).join(replacement);
      });
      if (next !== raw) node.nodeValue = next;
    });
  };

  const metadataByUuid = () => {
    const records = new Map();
    document.querySelectorAll('.jdgm-review-widget-data').forEach((script) => {
      const source = script.textContent || '';
      const assignment = source.match(/reviewWidget\[[^\]]+\]\s*=\s*(\{[\s\S]*\})\s*$/);
      if (!assignment) return;
      try {
        const payload = JSON.parse(assignment[1]);
        [...(payload.photo_gallery || []), ...(payload.reviews || [])].forEach((review) => {
          if (review && review.uuid) records.set(review.uuid, review);
        });
      } catch (_) {}
    });
    return records;
  };

  const addBadge = (card, label, modifier) => {
    const reviewerLine = card.querySelector('.jm-reviewer-info__details > .jm-cluster');
    if (!reviewerLine || reviewerLine.querySelector('.pd-review-badge--' + modifier)) return;
    const badge = document.createElement('span');
    badge.className = 'pd-review-badge pd-review-badge--' + modifier;
    if (modifier === 'verified' && label === 'Verified by shop') {
      const image = document.createElement('img');
      image.src = 'https://judgeme-public-images.imgix.net/judgeme/verified-badge-v2/verified-by-shop_light.svg';
      image.alt = 'Verified by Shop';
      image.width = 97;
      image.height = 20;
      badge.appendChild(image);
    } else {
      badge.textContent = label;
    }
    reviewerLine.appendChild(badge);
  };

  const enhance = () => {
    scheduled = false;
    normalizeStorefrontCopy();
    const records = metadataByUuid();
    document.querySelectorAll(WIDGET_SELECTOR).forEach((widget) => {
      widget.querySelectorAll(CARD_SELECTOR).forEach((card) => {
        const uuid = card.getAttribute('review-uuid');
        const review = records.get(uuid);
        const hasMedia = Boolean(
          card.querySelector('.jm-media-thumbnail-list__thumbnail, .jm-media-preview, [aria-label="View review image"]') ||
          (review && ((review.pictures_urls || []).length || (review.video_external_ids || []).length))
        );
        if (hasMedia) card.classList.add('pd-review-has-media');
        card.classList.add('pd-review-is-verified');
        addBadge(card, 'Verified by shop', 'verified');
        const reviewContent = card.querySelector('.jm-review-content');
        if (reviewContent && !reviewContent.querySelector('.pd-review-shop-note')) {
          const note = document.createElement('div');
          note.className = 'pd-review-shop-note';
          note.textContent = 'Review verified by shop';
          reviewContent.appendChild(note);
        }
      });
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();